import React, { useLayoutEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

const STORAGE_KEY = 'spg-cookie-consent';
const LEGACY_COOKIE = 'acceptCookies';

export function getCookieConsent() {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (e) {
    /* ignore */
  }
  if (typeof document !== 'undefined' && document.cookie.indexOf(`${LEGACY_COOKIE}=true`) !== -1) {
    return { necessary: true, statistics: true };
  }
  return null;
}

export function openCookieSettings() {
  window.dispatchEvent(new Event('spg-cookie-settings'));
}

function saveConsent(consent) {
  const payload = {
    necessary: true,
    statistics: Boolean(consent.statistics),
    updated: new Date().toISOString(),
  };
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (e) {
    /* ignore */
  }
  document.cookie = `${LEGACY_COOKIE}=${payload.statistics ? 'true' : 'necessary'}; path=/; max-age=31536000; SameSite=Lax`;
  window.dispatchEvent(new CustomEvent('spg-cookie-consent', { detail: payload }));
  return payload;
}

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [statistics, setStatistics] = useState(() => Boolean(getCookieConsent()?.statistics));

  useLayoutEffect(() => {
    const open = () => {
      const current = getCookieConsent();
      setStatistics(Boolean(current?.statistics));
      setVisible(true);
    };
    const onReady = () => {
      if (!getCookieConsent()) {
        setVisible(true);
      }
    };
    window.addEventListener('spg-cookie-settings', open);
    window.addEventListener('spg-page-ready', onReady);
    return () => {
      window.removeEventListener('spg-cookie-settings', open);
      window.removeEventListener('spg-page-ready', onReady);
    };
  }, []);

  if (!visible) {
    return null;
  }

  const choose = (allowStatistics) => {
    saveConsent({ statistics: allowStatistics });
    setVisible(false);
  };

  return (
    <div className="spg-cookie-banner" role="dialog" aria-label="Cookie-Einstellungen">
      <div className="spg-cookie-copy">
        <strong>Cookies</strong>
        <p>
          Wir verwenden technisch notwendige Cookies. Google Analytics (Statistik) setzen wir nur mit Ihrer Zustimmung.
          Details in der <RouterLink to="/datenschutz">Datenschutzerklärung</RouterLink>.
        </p>
        <label className="spg-cookie-option">
          <input
            type="checkbox"
            checked={statistics}
            onChange={(event) => setStatistics(event.target.checked)}
          />
          Statistik (Google Analytics)
        </label>
      </div>
      <div className="spg-cookie-actions">
        <button type="button" className="spg-cookie-decline" onClick={() => choose(false)}>
          Nur notwendige
        </button>
        <button type="button" className="spg-cookie-save" onClick={() => choose(statistics)}>
          Auswahl speichern
        </button>
        <button type="button" className="spg-btn" onClick={() => choose(true)}>
          Alle akzeptieren
        </button>
      </div>
    </div>
  );
}
